import React from "react"
import { useGeneralSettings } from "hooks/useGeneralSettings"
import { useSideNav } from "hooks/useSideNav"
import { AnchorNumber } from "components/anchor-number/AnchorNumber"

interface MultipleNumberButtonProps {
  isSecondCTA?: boolean
  extraClassNames?: string
}

export const MultipleNumberButton = ({
  isSecondCTA = false,
  extraClassNames = "side-nav__button",
}: MultipleNumberButtonProps) => {
  const { trackingNumbers, usePhoneNumberNotTrackingNumber } =
    useGeneralSettings()
  const { handleCloseNav } = useSideNav()
  return (
    <>
      {trackingNumbers.map(({ trackingNumber, phoneNumber, id, label }) => {
        if (usePhoneNumberNotTrackingNumber && !phoneNumber) return <></>
        if (!usePhoneNumberNotTrackingNumber && !trackingNumber) return <></>
        return (
          <>
            <p className="side-nav__tracking-label">{label}</p>
            <AnchorNumber
              key={id}
              baseClassName={extraClassNames}
              phoneNumber={phoneNumber}
              classNameModifier="--cta"
              trackingNumber={trackingNumber}
              showIcon={false}
              onClick={handleCloseNav}
            />
          </>
        )
      })}
    </>
  )
}
